module.exports = __webpack_public_path__ + "static/media/item__food-4.2f8986e8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/atlas/dinerGame/item__food-4.png
// module id = 2329
// module chunks = 0